import { useEffect, useState } from "react";
import { useNavigate } from "react-router";
import { getApiBase, setApiBase, setToken } from "../lib/auth";

export default function Login() {
  const nav = useNavigate();
  const [base, setBase] = useState(getApiBase());
  const [token, setTokenField] = useState("");
  const [err, setErr] = useState<string | null>(null);

  useEffect(() => { setErr(null); }, [token, base]);

  async function submit(e: React.FormEvent) {
    e.preventDefault();
    setErr(null);
    setApiBase(base.trim());
    setToken(token.trim());
    // Probe an authenticated endpoint to validate before navigating.
    try {
      const probe = await fetch(`${base.trim()}/admin/queue/depth`, {
        headers: { authorization: `Bearer ${token.trim()}` },
      });
      if (probe.status === 401) {
        setToken(null);
        setErr("Token rejected by the Worker.");
        return;
      }
      if (!probe.ok) {
        setErr(`Probe failed: ${probe.status}`);
        return;
      }
      nav("/library", { replace: true });
    } catch (e) {
      setErr(e instanceof Error ? e.message : String(e));
    }
  }

  return (
    <div className="min-h-screen grid place-items-center px-4">
      <form onSubmit={submit} className="w-full max-w-sm space-y-5">
        <div>
          <div className="text-xs uppercase tracking-widest text-slate-500">Rainfall</div>
          <h1 className="text-xl font-semibold">Admin sign in</h1>
          <p className="text-xs text-slate-500 mt-1">
            Behind Cloudflare Access in prod. Enter the Worker bearer token to talk to the API.
          </p>
        </div>
        <label className="block text-sm">
          <span className="text-slate-400">API base URL</span>
          <input
            value={base}
            onChange={e => setBase(e.target.value)}
            className="mt-1 w-full bg-slate-900 border border-slate-800 rounded px-3 py-2 text-sm outline-none focus:border-rainfall-accent"
            placeholder="https://api.rainfallmeditation.com"
          />
        </label>
        <label className="block text-sm">
          <span className="text-slate-400">Worker bearer token (RAINFALL_ADMIN_TOKEN)</span>
          <input
            value={token}
            onChange={e => setTokenField(e.target.value)}
            type="password"
            className="mt-1 w-full bg-slate-900 border border-slate-800 rounded px-3 py-2 text-sm font-mono outline-none focus:border-rainfall-accent"
          />
        </label>
        {err && <div className="text-sm text-rainfall-bad">{err}</div>}
        <button
          type="submit"
          className="w-full bg-rainfall-accent text-slate-950 rounded px-3 py-2 text-sm font-medium hover:bg-rainfall-accent/90"
        >
          Sign in
        </button>
      </form>
    </div>
  );
}
